import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import { ApiService } from "./api.service";
import { ActivatedRoute, Router } from "@angular/router";
import { CommonService } from "./common.service";
import {CookieService} from 'ngx-cookie-service';
import {PlatformLocation} from '@angular/common';
import { StoreService } from './store.service';

@Component({
	selector: 'app-learning-map-wrap',
	templateUrl: './learning-map-wrap.component.html',
	styleUrls: ['./learning-map-wrap.component.css']
})
export class LearningMapWrapComponent implements OnInit, AfterViewInit, OnDestroy{
  refreshSubscribe:any;
	page: string;
	learningTour: any;
	methodId: number;
	status: any;
	showLeadership:boolean = false;
	user_id:any;
	user_target: boolean = false;
  isShowLoadingComponent: boolean = true;
  themeBG: string = "company"; //主题背景
  isShowEnterAnimate: boolean = false; //是否显示切换动画
  projectList: any;  // 项目列表
  campList: any; //训练营列表
  isShowPrompt: boolean = false; //是否显示toast
  promptText: string = "";
  nothingText: string="";
  code: number = 0;//智能陪练短链校验码
	constructor(private apiService: ApiService,
    private commonService: CommonService,
    private cookieService: CookieService,
    private route: ActivatedRoute,
    private store:StoreService,
    private platformLocation: PlatformLocation,
		private router: Router) {}

  ngOnDestroy(){
    this.refreshSubscribe.unsubscribe();
  }
	ngOnInit() {
		// 清除项目相关信息
    this.commonService.removeStorage("projectmsg");
    this.commonService.removeStorage("learningPathMetaId");
    this.commonService.removeStorage("projectId");
    this.commonService.removeStorage("skuId");
    this.commonService.removeStorage('moduleId');
    this.commonService.removeStorage("onlyCamp");
    this.commonService.removeStorage('campId');
    this.commonService.removeStorage('haveExerciseBook');
    this.commonService.removeStorage('isHaveTools');
    this.commonService.removeStorage('backurl');
    window.sessionStorage.removeItem('companyId');
    // this.themeBG = localStorage.getItem('themeBG') ? localStorage.getItem('themeBG') : this.themeBG;
		this.route.params.subscribe(params => {
		  this.methodId =  params['methodId'] ?  params['methodId'] : 1;
		  this.isShowEnterAnimate = Number(this.methodId) === -1;
		});

		this.route.queryParams.subscribe(params=>{
			this.code = params['code'];
			this.nothingText = this.code == 101 ? '项目暂未发布':'';
			this.promptText = params['code'] == 102 ? '没有分配该任务，请联系管理员':'';
		})
		// const herfUrl = this.platformLocation['location']['origin']
		// if(herfUrl === 'https://m-dev.transtalent.cn' || herfUrl === 'http://localhost:4200'){
		// 	// 获取项目数据
		// 	this.getProjectProgress().then(res => {
		// 		if(res.length > 0){
		// 			this.projectList = res
		// 			this.getProjectCourses();
		// 		}else{
		// 			this.getApiData();
		// 		}
		// 	})
		// }else{
		// 	this.getApiData();
		// }

		const herfUrl = this.platformLocation['location']['origin']
		// if(herfUrl === 'https://m-dev.transtalent.cn' || herfUrl === 'http://localhost:4200'){
			// 获取项目数据
			this.getProjectProgress().then(res => {
				this.projectList = res.filter(item => item['type'] !==2);
        		this.campList = res.filter(item => item['type'] === 2);
			}).then(()=>{
				return this.getUserInfo().then(result=>{
          window.sessionStorage.setItem('companyId',result.companyId);
				  this.commonService.setStorage('userName',result.name);
					this.commonService.setStorage("companyType",result.companiesType)
					$('#userIdContainer').val(result.id);
					this.commonService.setStorage('userId',result.id);
					return this.themeBG = {1:'open',2:'experience'}[result.companiesType]||'company';
				});
			}).then(()=>{
				// return this.getEveryDayTask()
			this.getProjectCourses();  // 项目外课程
			if(this.campList){
				this.commonService.setStorage('haveExerciseBook',this.campList);
			}
      })
		// }else{
		// 	this.getApiData();
		// }


		// this.getApiData();

    this.refreshSubscribe = this.store.notification.refreshHomePage.subscribe(value => {
      if(value === true && this.page === 'nothing'){
        (this.platformLocation as any).location.reload()
      }
    })
	}
  doAskImmediatelyOrNot(){
    this.store.notification.askImmediately.next(true);//直接轮询一次
  }
  ngAfterViewInit(){
    this.commonService.initPage();
	}



	getApiData(){
    this.status = 1;
	  this.getLearningTour().then(result=>{
			//将第一个标记为专业版测试用
			// result.learning_path_metas[0].isProfeshional = true;
			//over
			this.learningTour = result;
    }).then(()=>{
      if(this.learningTour){
        this.user_id = this.learningTour.user_id;
      }
      if(Number(this.methodId)!==1 && Number(this.methodId)!==-1){
        this.goToOpenClass();
      }else{
        this.setabilityIndex();
        this.redirection();
      }
    });
  }

  /**
   * 获取训练营的id
   * @param projectId: Number 项目Id
   */
  getEveryDayTask(projectId: number):Promise<any>{
	  return this.apiService.ajax({
      'type': 'GET',
      'url': 'ddilearner/v2/camp/everyDayTask/' + projectId
    }).toPromise();
  }

  	// 项目外课程
	getProjectCourses(){
		this.status = 1;
		this.getCoursesOrProjectCourses().then(result=>{
			//将第一个标记为专业版测试用
			// result.learning_path_metas[0].isProfeshional = true;
			//over
      // result.learning_path_metas = result.learning_path_metas.filter(item=> Number(item.id) !== 7001);
      // console.log('filter之后的数据',result);
      this.learningTour = result;
			this.learningTour.projectList = this.projectList;
		}).then(()=>{
			return this.getUserInfo().then(result=>{
				this.commonService.setStorage('userName',result.name);
				this.commonService.setStorage("companyType",result.companiesType);
				return this.themeBG = {1:'open',2:'experience'}[result.companiesType]||'company';
			});
		}).then(()=>{
			if(this.learningTour){
				this.user_id = this.learningTour.user_id;
				$('#userIdContainer').val(this.user_id);
				this.commonService.setStorage('userId',this.user_id);
			}
			if(Number(this.methodId)!==1 && Number(this.methodId)!==-1){
				this.goToOpenClass();
			}else{
				this.setabilityIndex();
				this.redirection();
			}
		});
	}

  	//项目列表接口和项目学习进度接口
  	getProjectProgress(){
      return this.apiService.ajax({
      'type': 'GET',
      'url': 'ddilearner/v2/user/learning/projectProgress?needDetails=true',
      }).toPromise();
	}

	//获取项目下课程列表或者散客列表
	getCoursesOrProjectCourses(){
		return this.apiService.ajax({
		  'type': 'GET',
		  'url': 'sr/v2/coursesOrProjectCourses',
		}).toPromise();
	}

  //获取LearningTour
  getLearningTour(){
	  return this.apiService.ajax({
      'type': 'get',
      'url': '/sr/v2/learningtournew'
    }).toPromise();
  }



  //获取用户信息
  getUserInfo(){
	  return this.apiService.getUserInfo().toPromise();
  }


	mockData(){
	  this.status = 1;
	  this.learningTour ={"user_id":3327,"tour_meta_id":174,"tour_id":3555,"tour_name":"项目学习学习流程","show_guide_page":false,"dna_survey_meta_id":1,"pre_survey_meta_ids":[],"post_survey_meta_ids":[],"celebration_meta_id":0,"finished":false,"learning_path_metas":[{"id":1,"name":"辅导","enabled":1,"finished":true,"learningPathId":13117,"version":1,"description":"优秀领导者必备的辅导技巧 ","progress":0},{"id":2,"name":"打造高效团队","enabled":1,"finished":true,"learningPathId":13119,"version":1,"description":"激发团队绩效的成功法则","progress":0},{"id":12,"name":"领导力精要","enabled":1,"finished":true,"learningPathId":13120,"version":0,"description":"无往不胜的管理沟通心法","progress":0},{"id":13,"name":"计划与组织","enabled":1,"finished":true,"learningPathId":13122,"version":1,"description":"计划从容不迫，行动游刃有余","progress":0},{"id":14,"name":"协作","enabled":1,"finished":true,"learningPathId":13125,"version":1,"description":"打造良好伙伴关系的秘诀","progress":0},{"id":11,"name":"授权","enabled":1,"finished":true,"learningPathId":13126,"version":1,"description":"解决授权下属的五大挑战","progress":0},{"id":15,"name":"影响力","enabled":1,"finished":true,"learningPathId":13127,"version":1,"description":"成功影响他人的策略与技巧","progress":0},{"id":16,"name":"决策","enabled":1,"finished":true,"learningPathId":13123,"version":1,"description":"做出优质决策的五步骤","progress":0},{"id":18,"name":"领导力启程","enabled":1,"finished":true,"learningPathId":13121,"version":0,"description":"新任领导者的角色转型","progress":0},{"id":0,"name":"领导力DNA","enabled":1,"finished":true,"learningPathId":3555,"version":0,"description":"测一测：你的领导力个性画像","progress":0},{"id":20,"name":"驱动变革","enabled":1,"finished":true,"learningPathId":13124,"version":1,"description":"加速变革，你要了解的法则与工具","progress":0},{"id":24,"name":"达至最佳绩效","enabled":1,"finished":false,"learningPathId":26908,"version":1,"description":"做好绩效管理的必备技能","progress":0},{"id":26,"name":"目标选才","enabled":1,"finished":false,"learningPathId":0,"version":1,"description":"练就面试的火眼金睛","progress":0},{"id":22,"name":"影响力增强版","enabled":1,"finished":false,"learningPathId":0,"version":1,"description":"成功影响他人的策略与技巧","progress":0},{"id":28,"name":"解决冲突","enabled":1,"finished":false,"learningPathId":26905,"version":1,"description":"应对冲突时的“道”与“术”","progress":0}],"dna_survey_done":true,"pre_survey_done":false,"post_survey_done":false,"learning_process":2,"c1":0};
    this.commonService.setStorage('openClass','1');
    this.goToOpenClass();
    this.isShowLoadingComponent = false;
	}

	goToNothingPage(){
		this.page = 'nothing';
	}
	//转向处理
	redirection(){
		if(this.status == 4) {
			let link = ['success'];
			this.router.navigate(link);
		} else {
			if(this.learningTour.learning_path_metas.length==0 && this.campList.length ==0 && (this.learningTour.projectList && this.learningTour.projectList.length == 0)) {
			  this.goToNothingPage()
			}else{
				//统一定位到新课程
				// this.goToNewMainPage();
				this.commonService.removeStorage('onlyCamp');
				// this.commonService.removeStorage('skuId');
				this.goToMainPage();
			}
			// else if(this.learningTour.learning_path_metas.length==0 && this.campList.length ==1 && (this.learningTour.projectList && this.learningTour.projectList.length == 0)){
			//   	this.commonService.setStorage('onlyCamp','onlyCamp');
			// 	this.commonService.setStorage('skuId',this.campList[0]['projectId']);
        	// 	this.commonService.setStorage('campId',this.campList[0]['campMetasId']);
			// 	this.router.navigate(['learning-camp',this.campList[0]['projectId'],this.campList[0]['campMetasId'],-1]);
      	// }

			//关闭loading
      	this.isShowLoadingComponent = false;
		this.isShowPrompt = this.code == 102 ? true : false;
		setTimeout(()=>{
			this.isShowPrompt = false;
		},3000);
    	}

    this.doAskImmediatelyOrNot();//执行轮询
	}


	setabilityIndex(){
		let abilityArray = ['辅导', '打造高效团队', '决策', '协作', '授权', '影响力', '领导力精要', '计划与组织'];
		// 领导力启程 在旧的地图中不显示.
		if(!this.learningTour.learning_process || this.learningTour.learning_process != 2){
			let removeIndex = this.getTargetIndex(this.learningTour.learning_path_metas);
			if(removeIndex >= 0){
				this.showLeadership = true;
				this.learningTour.learning_path_metas.splice(removeIndex, 1);
			}
		}

		this.learningTour.learning_path_metas.forEach(function(item, index) {
			abilityArray.forEach(function(subItem, subIndex) {
				if(item.name == subItem) {
					item.abilityIndex = subIndex;
				}
			});
		});
	}

	goToOpenClass(){
    this.page = 'openClass';
  }

	goToMainPage() {
		this.page = 'main';
	}

	goToNewMainPage() {
		this.page = 'newmain';
	}

	redirectNewPage(){
		//统一定位到新课程页
    this.goToMainPage();

		// if(this.learningTour.learning_process && this.learningTour.learning_process == 2){
		// 	//新课程转向
		// 	this.goToNewMainPage();
		// } else {
		// 	this.goToMainPage();
		// }
	}

	getTargetIndex(arr) {
		let len = arr.length;
		for(let i = 0; i < len; i += 1) {
			if(arr[i].name == '领导力启程') {
				return Number(i);
			}
		}
		return -1;
	}
}



// WEBPACK FOOTER //
// ./src/app/learning-map-wrap.component.ts